<template>
  <main class="withdraw-record-target">
    <header class="withdraw-record-target__header">
      <button type="button" :aria-label="$t('frontend.common.back')" @click="back"><van-icon name="arrow-left" /></button>
      <h1>{{ $t('frontend.finance.withdraw_detail') }}</h1>
      <span></span>
    </header>
    <van-pull-refresh v-model="isLoading" class="withdraw-record-target__refresh" @refresh="onRefresh">
      <section class="withdraw-record-target__list">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <article v-for="(item, index) in list" :key="item.id || index" class="withdraw-record-card">
          <header>
            <strong :class="{ 'is-approved': item.status === 2 || item.status === 4 }">{{ item.status_text }}</strong>
            <span>{{ $t('frontend.finance.record_amount', { amount: item.money }) }}</span>
          </header>
          <p>{{ $t('frontend.finance.illustrate', { text: item.desc || '-' }) }}</p>
          <p>{{ $t('frontend.finance.submission_time', { time: item.create_time }) }}</p>
          <p>{{ $t('frontend.finance.review_time', { time: item.update_time || item.status_text }) }}</p>
        </article>
      </section>
    </van-pull-refresh>
  </main>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getUserWithdrawList();
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = Array.isArray(res.data) ? res.data : [];
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      }).finally(() => { this.isLoading = false; })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style scoped>
.withdraw-record-target { min-height: 100vh; background: #f7f7fa; color: #2d2636; }
.withdraw-record-target__header { height: 3.3125rem; display: grid; grid-template-columns: 2.5625rem 1fr 2.5625rem; align-items: center; background: #fff; }
.withdraw-record-target__header button { border: 0; background: transparent; color: #443a50; font-size: 1.2rem; }
.withdraw-record-target__header h1 { margin: 0; font-size: 1.25rem; font-weight: 700; text-align: center; }
.withdraw-record-target__refresh { min-height: calc(100vh - 3.3125rem); }
.withdraw-record-target__list { padding: 1rem 0.6875rem; }
.withdraw-record-card { min-height: 8.5rem; margin-bottom: 1.0625rem; padding: 0.5rem; background: #fff; }
.withdraw-record-card header { display: flex; align-items: center; justify-content: space-between; min-height: 2.0625rem; font-size: 0.88rem; }
.withdraw-record-card header strong { color: #b4763d; }
.withdraw-record-card header .is-approved { color: #2e9a62; }
.withdraw-record-card header span { color: #3b3343; }
.withdraw-record-card p { margin: 0; min-height: 1.38rem; color: #615a68; font-size: 0.78rem; line-height: 1.38rem; }
</style>
